import WazzupPage from './WazzupPage';

export default WazzupPage;
